export const APP_DOWNLOAD_BEGIN = {
  eventAction: 'AppDownloadBegin',
};

export const SMART_BANNER_LOADED = {
  eventAction: 'SmartBannerLoaded',
};
